import React from "react";
import { Navigate } from "react-router-dom";
import { getRole } from "@/utils/auth";

type Props = { children: React.ReactNode; allow: string[] };

export default function RoleGate({ children, allow }: Props) {
    const role = getRole();

    // If no role found in storage, redirect to login
    if (!role) {
        return <Navigate to="/login" replace />;
    }

    // If role is not in the allowed list, redirect to home
    if (!allow.includes(role)) {
        return <Navigate to="/" replace />;
    }

    // Otherwise, render the child component(s)
    return <>{children}</>;
}
